import { styled } from '@mui/material/styles';

import { Theme, palette } from '../../theme';

export const StyledAsterisk = styled('span')<{ $color?: string }>`
    ${({ theme }: { theme: Theme }) => theme.typography.bodySmall};
    color: ${({ $color }) => $color ?? palette.primary.main};
`;
